__turbopack_context__.v({
  "HomePageSection": "IndexPage-module__0sQVSq__HomePageSection",
  "PromoRibbon-instructional": "IndexPage-module__0sQVSq__PromoRibbon-instructional",
  "PromoRibbon-retailer": "IndexPage-module__0sQVSq__PromoRibbon-retailer",
  "contentHomepage": "IndexPage-module__0sQVSq__contentHomepage",
  "grid-item": "IndexPage-module__0sQVSq__grid-item",
  "h-card": "IndexPage-module__0sQVSq__h-card",
  "h-card-details": "IndexPage-module__0sQVSq__h-card-details",
  "instructional": "IndexPage-module__0sQVSq__instructional",
  "large-2": "IndexPage-module__0sQVSq__large-2",
  "promo-subheader": "IndexPage-module__0sQVSq__promo-subheader",
  "promoImage": "IndexPage-module__0sQVSq__promoImage",
  "promoItem": "IndexPage-module__0sQVSq__promoItem",
  "v-card-img-top": "IndexPage-module__0sQVSq__v-card-img-top",
});
